import { folderApi } from '@_entities/content';

import { useDeleteFolderMutation, useUpdateFolderMutation } from '../mutation';
import { useFolderListQuery } from '../useFolderListQuery';

export function useFolderAction() {
	const { data: folderList } = useFolderListQuery('manual');

	const { mutateProps, updateFolderName } = useUpdateFolderMutation();

	function getFolderName(folderId: number) {
		const findFolder = folderList?.find((folder) => folder.id === folderId);
		return findFolder?.name ?? '';
	}

	async function createFolder(name: string) {
		return folderApi.createFolder(name);
	}

	const deleteFolderMutation = useDeleteFolderMutation();

	return {
		mutateProps,
		updateFolderName,
		getFolderName,
		createFolder,
		deleteFolder: deleteFolderMutation.mutateAsync,
	};
}
